import { Component, inject, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { MatSortModule, MatSort } from '@angular/material/sort';
import { MatPaginatorModule, MatPaginator } from '@angular/material/paginator';
import { MatTooltip } from '@angular/material/tooltip';
import { MatRippleModule } from '@angular/material/core';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { DialogService } from '@adgate/common/services/dialog-service';
import { ObjectDescPipe } from '@adgate/common/pipes/object-desc-pipe';
import { TvCommercialFiltersDialogComponent } from '@adgate/modules/tv/dialogs/tv-commercial-filters-dialog-component/tv-commercial-filters-dialog-component';
import { CommercialFilter } from '@adgate/modules/tv/types/commercial-filter.type';
import { filter, switchMap } from 'rxjs';
import { TvService } from '@adgate/modules/tv/services/tv-service';
import { RESTApplicationResponse } from '@adgate/common/types/rest-application-response.type';
import { Commercial } from '@adgate/modules/tv/types/commecial.type';

@Component({
  selector: 'app-link-master-commercial-dialog-component',
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatTooltip,
    ClipboardModule,
    MatRippleModule,
    MatSnackBarModule,
    ObjectDescPipe
  ],
  providers: [DatePipe],
  templateUrl: './link-master-commercial-dialog-component.html',
  styleUrl: './link-master-commercial-dialog-component.scss',
})
export class LinkMasterCommercialDialogComponent implements OnInit, AfterViewInit
{
  private dialogRef: MatDialogRef<LinkMasterCommercialDialogComponent> = inject(MatDialogRef<LinkMasterCommercialDialogComponent>);
  private dialogService: DialogService = inject(DialogService);
  private tvService: TvService = inject(TvService);
  public data: any = inject(MAT_DIALOG_DATA, { optional: false });

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  displayedColumns: string[] = ['refCode', 'brand', 'product', 'refTitle', 'filename', 'language', 'type', 'uploaded', 'actions'];
  dataSource: MatTableDataSource<any>;

  constructor()
  {
    this.dataSource = new MatTableDataSource<any>([]);
  }

  ngOnInit(): void
  {

  }

  ngAfterViewInit()
  {
    this.dataSource.sortingDataAccessor = this.getTableDataAccessor();
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  getTableDataAccessor(): any
  {
    return (item: any, property: any) => {
      switch (property) {
        case 'refCode': return item.referenceCode;
        case 'brand': return item.brand;
        case 'product': return item.product;
        case 'refTitle': return item.version;
        case 'filename': return item.filename;
        case 'language': return item.language?.description;
        case 'type': return item.type?.description;
        case 'uploaded': return item.dateCreated;
        default: return item[property];
      }
    };
  }

  onSearchCommercials()
  {
    const dialogRef = this.dialogService.openAnyDialog(TvCommercialFiltersDialogComponent, {
      data: new CommercialFilter,
      width: '700px',
      maxWidth: '90vw',
      disableClose: true
    });

    dialogRef.afterClosed().pipe(
      filter((result: CommercialFilter | null) => result != null),
      switchMap((result: CommercialFilter) => {
        this.dialogService.showProgress();
        return this.tvService.getCommercials(result);
      })
    ).subscribe({
      next: (r:RESTApplicationResponse) => {
        this.dataSource.data = r.data;
        this.dialogService.hideProgress();
      },
      error: (err:Error) => {
        this.dialogService.openErrorDialog(err.message);
      }
    });
  }

  onCancel(): void
  {
    this.dialogRef.close(null);
  }

  onLinkSelectedCommercial(commercial: Commercial): void
  {
    this.dialogRef.close(commercial);
  }
}
